export default __webpack_public_path__ + "static/media/proem-logo.4cedc99c.png";